module.exports = __webpack_public_path__ + "static/media/purchase.599ca5cb.png";